import { useState } from 'react';
import TicketsList from './List.jsx';
import TicketForm from './Form.jsx';
import TicketDetail from './Detail.jsx';

export default function TicketsPage() {
  const [view, setView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);

  if (view === 'form') {
    return (
      <TicketForm
        onCancel={() => setView('list')}
        onCreated={(id) => {
          if (id) {
            setSelectedId(id);
            setView('detail');
          } else {
            setView('list');
          }
        }}
      />
    );
  }

  if (view === 'detail' && selectedId) {
    return (
      <TicketDetail
        ticketId={selectedId}
        onBack={() => {
          setView('list');
          setSelectedId(null);
        }}
      />
    );
  }

  return (
    <TicketsList
      onCreate={() => setView('form')}
      onSelectTicket={(ticket) => {
        setSelectedId(ticket.id);
        setView('detail');
      }}
    />
  );
}
